import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgxEchartsModule } from "ngx-echarts";
import { SharedModule } from "../shared/shared.module";
import { MaiaPageComponent } from "./maia-page/maia-page.component";
import { MaiaStepHeaderComponent } from "./maia-step-header/maia-step-header.component";
import { MaiaChatPanelComponent } from "./maia-chat-panel/maia-chat-panel.component";
import { MaiaUploadStepComponent } from "./maia-upload-step/maia-upload-step.component";
import { MaiaReviewStepComponent } from "./maia-review-step/maia-review-step.component";
import { MaiaGeocodeStepComponent } from "./maia-geocode-step/maia-geocode-step.component";
import { MaiaPrepareStepComponent } from "./maia-prepare-step/maia-prepare-step.component";
import { MaiaGuidelinesPanelComponent } from "./maia-guidelines-panel/maia-guidelines-panel.component";
import { MaiaLeaveDialogComponent } from "./maia-leave-dialog/maia-leave-dialog.component";
import { MaiaGroupStepComponent } from "./maia-group-step/maia-group-step.component";
import { MaiaEnrichStepComponent } from "./maia-enrich-step/maia-enrich-step.component";
import { MaiaEnhanceStepComponent } from "./maia-enhance-step/maia-enhance-step.component";
import { MaiaReportStepComponent } from "./maia-report-step/maia-report-step.component";
import { MaiaReportChartComponent } from "./maia-report-chart/maia-report-chart.component";
import { MaiaFieldSelectComponent } from "./maia-field-select/maia-field-select.component";
import { MaiaReadyStepComponent } from "./maia-ready-step/maia-ready-step.component";

/**
 * MAIA (Maptycs AI Assistant).
 *
 * UI: entry page and the upload → review → geocode → enrich → prepare → group
 * wizard steps.
 */
@NgModule({
    declarations: [
        MaiaPageComponent,
        MaiaStepHeaderComponent,
        MaiaChatPanelComponent,
        MaiaUploadStepComponent,
        MaiaReviewStepComponent,
        MaiaGeocodeStepComponent,
        MaiaPrepareStepComponent,
        MaiaGuidelinesPanelComponent,
        MaiaLeaveDialogComponent,
        MaiaGroupStepComponent,
        MaiaEnrichStepComponent,
        MaiaEnhanceStepComponent,
        MaiaReportStepComponent,
        MaiaReportChartComponent,
        MaiaFieldSelectComponent,
        MaiaReadyStepComponent,
    ],
    imports: [SharedModule, FormsModule, DragDropModule, MatTooltipModule, NgxEchartsModule],
    exports: [MaiaPageComponent],
})
export class MaiaModule {}
